<template>
  <div>
    <div class="bg">
      <div class="logo">
        <img :src="require('@/assets/logo.png')">
        <p>景区语音讲解</p>
      </div>
      <div class="flx">
        <p>订单状态</p>
        <span>支付成功</span>
      </div>
      <div class="flx">
        <p>订单尾号</p>
        <span>{{order_number}}</span>
      </div>
      <div class="flx flx2">
        <p>支付总额</p>
        <span>￥{{total}}</span>
      </div>
    </div>
    <div class="btn" @click="back()">开始讲解</div>
  </div>
</template>
<script type="text/javascript" charset="UTF-8" src="https://wx.gtimg.com/pay_h5/goldplan/js/jgoldplan-1.0.0.js"></script>
<script>
import axios from "axios";
export default {
  data() {
    return {
      order_number: "",
      total: 0,
      jid:1
    };
  },
  mounted(){
    const sub_mch_id = this.$route.query.sub_mch_id;
    const out_trade_no = this.$route.query.out_trade_no;
    const check_code = this.$route.query.check_code;

    axios.post(process.env.VUE_APP_BASE_URL+"/wx/CodeCheck", {
        sub_mch_id: sub_mch_id,
        out_trade_no: out_trade_no,
        check_code: check_code,
      }, {
        slient: true,
      }
    )
    .then((res) => {
      if(res.data.err==0){
        this.order_number = res.data.result.order_number
        this.total = res.data.result.total
        this.jid = res.data.result.jid
        localStorage.setItem('web_uid',res.data.result.web_uid);
        localStorage.setItem('jid',res.data.result.jid);
        let mchData ={action:'onIframeReady',displayStyle:'SHOW_CUSTOM_PAGE'}
        let postData = JSON.stringify(mchData)
        parent.postMessage(postData,'*')
      }else{
        let mchData ={action:'onIframeReady',displayStyle:'SHOW_OFFICIAL_PAGE'}
        let postData = JSON.stringify(mchData)
        parent.postMessage(postData,'*')
      }
    })
  },
  methods: {
    back(){
      let mchData2 ={action:'jumpOut', jumpOutUrl:'https://jpdl.jinpaidaolan.com/wx/index.html?code_type=3&jd_top=0&jid='+this.jid}
      let postData2 = JSON.stringify(mchData2)
      parent.postMessage(postData2,'*')
    },
  },
};
</script>

<style lang="scss" scoped>
.bg{
  background: #fff;
}
.logo{
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 4vw;
  font-weight: 700;
  img{
    width: 40vw;
    height: 33vw;
    padding: 10vw 10vw 3vw;
  }
}
.flx{
  display: flex;
  justify-content: space-between;
  margin: 0 4vw;
  padding: 2vw 0;
  p{
    color: #666;
  }
  &.flx2{
    border-top: 1px solid #d8d8d8;
    span{
      font-size: 5vw;
    }
  }
}
.btn{
  width: 92vw;
  height:12vw;
  line-height:12vw;
  font-size: 4vw;
  font-family: PingFangSC-Medium, PingFang SC;
  border-radius: 4px;
  background: #ed6c38;
  color: #fff;
  text-align: center;
  margin: 6vw auto;
}
</style>
